import type { RouterConfig } from '@nuxt/schema'
import { PAGE_URLS } from '~/config/page-url'

export default <RouterConfig>{
  scrollBehavior(to, from) {
    // pop-up
    if (to.path === from.path) {
      return
    }

    // Reload (F5) homepage: scroll to top
    if (to.fullPath === '/' && from.fullPath === '/' && to.fullPath === from.fullPath) {
      return { top: 0, behavior: 'smooth' }
    }

    const pageGroups = [PAGE_URLS.PROMOTION_CATEGORY, PAGE_URLS.NEWS]

    for (const page of pageGroups) {
      const isToPage = to.path.includes(page)
      const isFromPage = from.path.includes(page)

      if (isToPage) {
        if (!isFromPage) {
          return { top: 0, behavior: 'smooth' }
        }
        return
      }
    }

    // other pages
    return { top: 0, behavior: 'smooth' }
  }
}
